import { render, staticRenderFns } from "./ReactPage.vue?vue&type=template&id=afbdefdc"
import script from "./ReactPage.vue?vue&type=script&lang=js"
export * from "./ReactPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports